import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatSize',
  standalone: true
})
export class FormatSizePipe implements PipeTransform {
  transform(sizeInBytes: number): string {
    if (sizeInBytes === 0) return '0 Б';

    const units = ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ'];
    const k = 1024;
    const i = Math.floor(Math.log(sizeInBytes) / Math.log(k));
    const formattedSize = parseFloat((sizeInBytes / Math.pow(k, i)).toFixed(2));

    return `${formattedSize} ${units[i]}`;
  }
}
